

const componentSlider		= require('../../components/component-slider/component-slider.config');
const componentSocialBar	= require('../../components/component-socialbar/component-socialbar.config');
module.exports = {
	title: 'Sökresultat',
	bacon:'test',
	context: {
		title: 'Sökresultat',
	},
	componentSlider: 	componentSlider.context,
	componentSocialBar: componentSocialBar.context,
};
